"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "lnhqu5-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: ", ";\n    align-items: center;\n    justify-content: center;\n    position: ", ";\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%,-50%);\n    z-index: 100;\n    height: 120px;\n"])), function (props) {
  return props.hide ? 'none' : 'flex';
}, function (props) {
  return props.position || 'relative';
});

exports.Wrapper = Wrapper;

var Spinner = _styledComponents["default"].div.withConfig({
  displayName: "styled__Spinner",
  componentId: "lnhqu5-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: relative;\n    width: 50px;\n    height: 50px;\n    animation: anim linear 1.5s infinite;\n    &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        -webkit-transform: translate(-50%,-50%);\n        transform: translate(-50%,-50%);\n        background: url(", ") no-repeat center;\n        stroke: #fff;\n        background-size: 100%;\n        width: 100px;\n        height: 100px;\n        background-color: #475155;\n        border-radius: 50%;\n        opacity: .7;\n    }\n    @keyframes anim {\n        0% {\n          transform: rotate(-360deg)\n        }\n    }\n"])), require('../../assets/img/throbber--white.svg'));

exports.Spinner = Spinner;